// Returns a random integer between min (inclusive) and max (inclusive)
export default function getRandomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
